import React from 'react';
import { Badge } from '../../elements';
import theme from '../../constants/Theme';

type DiarySummaryBadgeVariant = 'positive' | 'neutral';

interface DiarySummaryBadgeProps {
  children: React.ReactNode;
  variant?: DiarySummaryBadgeVariant;
}

const DiarySummaryBadge: React.FC<DiarySummaryBadgeProps> = ({ children, variant = 'neutral' }) => {
  const getBadgeColors = () => {
    switch (variant) {
      case 'positive':
        return {
          backgroundColor: theme.colors.functionalGreenLight,
          fontColor: theme.colors.functionalGreen,
        };
      case 'neutral':
      default:
        return {
          backgroundColor: theme.colors.blueLight,
          fontColor: theme.colors.blue,
        };
    }
  };

  const { backgroundColor, fontColor } = getBadgeColors();

  return (
    <Badge backgroundColor={backgroundColor} fontColor={fontColor}>
      {children}
    </Badge>
  );
};

export default DiarySummaryBadge;
